import React from 'react';
import { Typography, Grid, useMediaQuery, Box } from "@mui/material";

const ActionCpc = ({ bgColor }) => {
    const isMobile = useMediaQuery('(max-width:600px)');

    const programs = [
        { 
            emoji: "💻", 
            title: "Информационные технологии", 
            description: "Программирование, цифровые навыки и разработка собственных проектов" 
        },
        { 
            emoji: "🤖", 
            title: "Робототехника и инженерия", 
            description: "Конструирование, моделирование и развитие инженерного мышления" 
        },
        { 
            emoji: "🧪", 
            title: "Естественные науки", 
            description: "Исследования, эксперименты и работа в современных лабораториях" 
        },
        { 
            emoji: "🌍", 
            title: "Иностранные языки", 
            description: "Развитие коммуникации и глобальных компетенций" 
        },
        { 
            emoji: "🎨", 
            title: "Дизайн и креативные индустрии", 
            description: "Графика, визуальное мышление и проектная деятельность" 
        },
        { 
            emoji: "🌱", 
            title: "Экология и зеленая экономика", 
            description: "Профессии будущего и устойчивое развитие" 
        }
    ];

    return (
        <Box sx={{ backgroundColor: bgColor, py: { xs: 6, md: 10 }, px: { xs: 2, md: 4 } }}>
            <Typography variant="h4" align="center" gutterBottom style={{ marginBottom: "50px", fontWeight: 'bold', color: 'text.primary' }} >
                Образовательные направления
            </Typography>
            
            <Box sx={{ maxWidth: '1200px', margin: '0 auto', width: '100%' }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                        {/* Левая колонка с программами */}
                        <Typography 
                            sx={{ 
                                mb: 4,
                                fontSize: isMobile ? '14px' : '16px',
                                color: 'text.secondary',
                                maxWidth: '520px',
                                margin: '0 auto',
                                textAlign: isMobile ? 'center' : 'left',
                                wordBreak: 'break-word'
                            }}
                        >
                            {/* Современные программы... */}
                        </Typography>

                        {programs.map((program, index) => (
                            <Box key={index} sx={{ mb: 2 }}>
                                <Typography 
                                    sx={{ 
                                        fontWeight: 600,
                                        fontSize: isMobile ? '15px' : '18px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        mb: 0.5,
                                        wordBreak: 'break-word'
                                    }}
                                >
                                    <span style={{ fontSize: '22px', flexShrink: 0 }}>{program.emoji}</span> 
                                    <span>{program.title}</span>
                                </Typography>

                                <Typography 
                                    sx={{ 
                                        fontSize: isMobile ? '13px' : '15px',
                                        color: 'text.secondary',
                                        pl: { xs: 3.5, sm: 4.5 },
                                        lineHeight: 1.4,
                                        wordBreak: 'break-word'
                                    }}
                                >
                                    {program.description}
                                </Typography>
                            </Box>
                        ))}
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        {/* Видео - отдельный div с центрированием */}
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            width: '100%',
                            height: '100%',
                            minHeight: isMobile ? '240px' : '420px'
                        }}>
                            <div style={{ 
                                width: '100%', 
                                maxWidth: '680px',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                            }}>
                                <iframe 
                                    src="https://vk.com/video_ext.php?oid=-132584949&id=456239784"
                                    title="VK video player"
                                    allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        width: '100%',
                                        height: isMobile ? '240px' : '420px',
                                        border: 'none',
                                        display: 'block',
                                        margin: 0,
                                        padding: 0
                                    }}
                                />
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default ActionCpc;